import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { ApiUrl } from "../../../ApiUrl";
import EditAdminUserModal from "./EditAdminUserModal";

const CreateNewRole = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [staffMap, setStaffMap] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    fetchStaffList();
    fetchRoles();
  }, []);

  useEffect(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();
    if (!normalizedSearch) {
      setFilteredRoles(roles);
      return;
    }

    setFilteredRoles(
      roles.filter((r) => {
        const roleName = (r.role_name || r.roleName || "").toString().toLowerCase();
        const userName = (r.user_name || r.userName || "").toString().toLowerCase();
        return roleName.includes(normalizedSearch) || userName.includes(normalizedSearch);
      })
    );
  }, [roles, searchTerm]);

  const fetchStaffList = async () => {
    try {
      const res = await fetch(
        `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.ok) {
        const result = await res.json();
        if (result.data) {
          const map = {};
          result.data.forEach((s) => { map[s.id] = s.employeeName; });
          setStaffMap(map);
        }
      }
    } catch (err) { console.error("Error fetching staff:", err); }
  };

  const fetchRoles = async (search = "") => {
    try {
      let url = `${ApiUrl.apiurl}AdminUser/List/?org_id=${orgId}&branch_id=${branchId}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      const res = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
      if (res.ok) {
        const result = await res.json();
        if (result.data) setRoles(result.data);
      }
    } catch (err) { console.error("Error fetching roles:", err); }
  };

  const formatModulesDisplay = (modules) => {
    if (!modules || modules.length === 0) return "All Modules";
    const groups = {};
    modules.forEach((m) => {
      if (m.includes(".")) {
        const parent = m.split(".")[0];
        groups[parent] = (groups[parent] || 0) + 1;
      } else {
        groups[m] = "All";
      }
    });
    return Object.entries(groups)
      .map(([k, v]) => `${k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, " ")} (${v})`)
      .join(", ");
  };

  const handleNew = () => navigate("/admin/create-new-role/new");
  const handleSearch = () => {
    const normalizedSearch = searchTerm.trim().toLowerCase();
    if (!normalizedSearch) {
      setFilteredRoles(roles);
      return;
    }

    setFilteredRoles(
      roles.filter((r) => {
        const roleName = (r.role_name || r.roleName || "").toString().toLowerCase();
        const userName = (r.user_name || r.userName || "").toString().toLowerCase();
        return roleName.includes(normalizedSearch) || userName.includes(normalizedSearch);
      })
    );
  };
  const handleClear = () => { setSearchTerm(""); fetchRoles(); };
  const handleClose = () => navigate("/admin/dashboard");
  const handleEdit = (role) => { setSelectedRole(role); setShowEditModal(true); };
  const handleModalClose = () => { setShowEditModal(false); setSelectedRole(null); };
  const handleUpdateSuccess = () => { fetchRoles(); handleModalClose(); };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0 ">
            <div className="card-body ">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ADMIN USER MANAGEMENT
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "150px" }}
                    onClick={handleNew}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "150px" }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{ width: "150px" }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex justify-content-center mt-4 mb-4">
                    <div
                      className="d-flex align-items-center w-100"
                      style={{ maxWidth: "560px", gap: "12px" }}
                    >
                      <label
                        className="form-label fw-bold mb-0"
                        style={{ minWidth: "170px" }}
                      >
                        Search by Role Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        style={{ height: "44px", fontSize: "15px", paddingLeft: "12px" }}
                        placeholder="Search by role name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-primary text-center">
                    <tr>
                      <th>S.No</th>
                      <th>Role Name</th>
                      <th>User Name</th>
                      <th>Non Teaching Staff</th>
                      <th style={{ minWidth: "300px" }}>Modules Access</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRoles.filter(
                      (r) => r.role_name && r.role_name.trim() !== "",
                    ).length > 0 ? (
                      filteredRoles
                        .filter((r) => r.role_name && r.role_name.trim() !== "")
                        .map((role, idx) => (
                          <tr key={role.id}>
                            <td className="text-center">{idx + 1}</td>
                            <td>{role.role_name || role.roleName || ""}</td>
                            <td>{role.user_name || role.userName || ""}</td>
                            <td>
                              {role.reference_id && role.reference_id !== 0
                                ? staffMap[role.reference_id] || "N/A"
                                : "N/A"}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}
                            >
                              {formatModulesDisplay(role.accessible_modules)}
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => handleEdit(role)}
                              >
                                <FaEdit className="me-1" />
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          No roles found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showEditModal && selectedRole && (
        <EditAdminUserModal
          show={showEditModal}
          handleClose={handleModalClose}
          roleData={selectedRole}
          staffMap={staffMap}
          onUpdateSuccess={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default CreateNewRole;
